// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TlNn","top":"styles_top__1GIAo","left":"styles_left__1UPaf","description":"styles_description__1w69f"};